var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboardLeftClick = function SvgKeyboardLeftClick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.401 19.58q1.9 1.9 4.599 1.9 2.698 0 4.599-1.9 1.9-1.901 1.901-4.6V9.02q0-2.699-1.901-4.6-1.9-1.9-4.599-1.9-2.698 0-4.599 1.9-1.9 1.901-1.901 4.6v5.96q0 2.699 1.901 4.6M17 9.02h-5V4.013c.293 0 .75.067.75.067q1.802.263 3.026 1.657T17 9.02m-1.463 9.498Q14.075 19.981 12 19.981q-2.075 0-3.537-1.463Q7 17.056 7 14.981v-4.462h10v4.462q0 2.074-1.463 3.537",
    clipRule: "evenodd"
  })));
};
export default SvgKeyboardLeftClick;